import { render, staticRenderFns } from "./StockInFastSuggestTable.vue?vue&type=template&id=684308e0&scoped=true"
import script from "./StockInFastSuggestTable.vue?vue&type=script&lang=ts"
export * from "./StockInFastSuggestTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684308e0",
  null
  
)

export default component.exports